export const SetLoginErrorMessage = (message) => {
  return {
    type: "SET_LOGIN_ERROR_MESSAGE",
    message: message,
  };
};

export const SetLoginInfoMessage = (message) => {
  return {
    type: "SET_LOGIN_INFO_MESSAGE",
    message: message,
  };
};

// for a password to be valid it must:
// Have >= 8 characters
// Contain a lowercase letter
// Contain an uppercase letter
// Contain a special character
// Contain a number
export const isPasswordValid = (password) => {
  return /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&/=?_.,:;\\-]){8,}/.test(
    password
  );
};
export default isPasswordValid;

export const SetLoginSigningIn = (value) => {
  return {
    type: "SET_LOGIN_SIGNING_IN",
    signingIn: value,
  };
};
